import { hashString } from './hashString';
export const createUniqueClassName = (block, elementName) => {
    const hash = hashString('universal-nav' + block + elementName);
    return `${block}__${elementName}-${hash}`;
};
//# sourceMappingURL=createUniqueClassName.js.map
// @zapier/universal-layout@11.0.68 (90b2cf70c)
